export async function loadGenericUniforms() {
  const response = await fetch('/api/generic-uniforms', { cache: 'no-store' });
  if (!response.ok) throw new Error(`Generic uniform service returned ${response.status}`);
  return response.json();
}

export async function saveGenericUniforms(uniforms) {
  const response = await fetch('/api/generic-uniforms', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ uniforms }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error || payload?.message || `Generic uniform service returned ${response.status}`);
  return payload;
}
